export const ENDPOINT_SERVER = process.env.VUE_APP_BELIVESDK_WEB_APP_ENDPOINT;
export const BASE_URL = process.env.VUE_APP_BELIVESDK_WEB_APP_BASE_URL;
export const ENDPOINT_CHAT = process.env.VUE_APP_CHAT_APP_ENDPOINT;
export const ENDPOINT_CHAT_HISTORY = process.env.VUE_APP_CHAT_APP_HISTORY_ENDPOINT;
export const ENDPOINT_TRACKING = process.env.VUE_APP_TRACKING_ENDPOINT;

export const STATUS_RESPONSES = {
   USER_BLOCKED_BY_HOST: 1309,
   USER_BANNED_BY_ADMIN: 1120,
   USERNAME_HAS_BEEN_TAKEN: 759,
   USER_NOT_FOUND: 652,
   SUCCESS: 1,
   PRIVATE_ROOM: 798,
   USER_LOGGED_ANOTHER_DEVICE: 1341,
   NOT_BUY_TICKET: 1424,
   UNAUTHORIZED: 401
};

export const STATUS_REMOTE_STREAM = {
   PLAYING: "PLAYING",
   STREAMING: "STREAMING",
   PAUSED: "PAUSED",
   STOPPED: "STOPPED",
   NEW: "NEW",
   END: "END"
};

export const DEVICE_TYPES = {
   ANDROID: "0",
   IOS: "1",
   WEB: "2"
};

export const MOBILE_OS = {
   ANDROID: "ANDROID",
   iOS: "iOS",
   WINDOW_PHONE: "Windows Phone",
   UN_KNOWN: "unknown"
};

export const DEFAULT_VALUES = {
   LOCATION: "JP",
   SLUG: "demo_slug",

   /*
    * Config for hard URLs:
    */
   // BASE_URL: "https://ak-texel01.akamaized.net/",
   BASE_URL: "",
   URL_SOURCES: [
      "https://primary-originshield.media-cloud.mobile.rakuten.co.jp/hls/keibatest/keibatest-Clear-2-0/master.m3u8",
      // "https://fcc3ddae59ed.us-west-2.playback.live-video.net/api/video/v1/us-west-2.893648527354.channel.DmumNckWFTqz.m3u8",
      // "https://primary-originshield.media-cloud.mobile.rakuten.co.jp/hls/keibaeventtest/keibaeventtest-Clear-2-0/master.m3u8",
      // "http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4",
      //"http://cdnapi.kaltura.com/p/1878761/sp/187876100/playManifest/entryId/1_usagz19w/flavorIds/1_5spqkazq,1_nslowvhp,1_boih5aji,1_qahc37ag/format/applehttp/protocol/http/a.m3u8",
      // "https://devstreaming-cdn.apple.com/videos/streaming/examples/img_bipbop_adv_example_fmp4/master.m3u8",
      // "https://fcc3ddae59ed.us-west-2.playback.live-video.net/api/video/v1/us-west-2.893648527354.channel.DmumNckWFTqz.m3u8"
      // "https://ak-texel01.akamaized.net/hls/live/2017085/stream05/index.m3u8",
      // "https://ak-texel01.akamaized.net/hls/live/2000341/test/master.m3u8",
      // "https://ak-texel01.akamaized.net/hls/live/2017085/stream05/index.m3u8",
      // "https://ak-texel01.akamaized.net/hls/live/2017088/stream08/index.m3u8",
      //  "https://111.109.3.176/hls/s/FW_CamFeed0/index.m3u8",
   ],
   // TOKEN: "st=1593416630~exp=1594021430~acl=/hls/live/*~hmac=3aed601fd909cd3d0603cadeb87ea5dc586cd3af900f5ed8c42b6d9d9240df51",
   TOKEN: "",
   /*
    * End hard URL
    */

   JSON_FILE: "https://ak-texel01.akamaized-staging.net/texel/catalog/testcatalog.json",
   // JSON_FILE: "https://ak-texel01.akamaized.net/texel/catalog/catalog.json",
   JSON_FILE_2: "https://ak-texel01.akamaized.net/texel/catalog/catalog.json",

   FAILED_URL_SOURCE:
      "http://cdnapi.kaltura.com/p/1878761/sp/187876100/playManifest/entryId/1_usagz19w/flavorIds/1_5spqkazq,1_nslowvhp,1_boih5aji,1_qahc37ag/format/applehttp/protocol/http/a.m3u8"
};

export const TOKEN_TYPES = {
   AKAIMA: "a",
   JWT: "j"
};

export const TESTING_CONFIGS = {
   IS_USING_LOCAL_JSON: false,
   IS_USING_AXIOS_TO_FETCH: false
};

export const RESOLUTION = {
   LOW: [360, 480],
   MEDIUM: [540, 720],
   HIGH: [1080, 1080]
};
